import React from 'react';
import { AsyncDocuments } from '@components-shared/DocumentsViewer/interfaces';
import {
  ColumnValueType,
  DetailsTableDataCommonType,
  IDetailsTableColumn,
} from '@components-shared/detailsTable/types';
import ENUM_CONSTANTS from '@components-shared/enum.constants';
import { FormattedDateTime } from '@components-shared/formattedDateTime';
import { keyMap } from '@locales/lokalise/keyMap';
import { getTableLabel, getValueFromEnums } from '@utils/helper';

export const DOC_VIEW_DESCRIPTION_COLUMNS: Array<IDetailsTableColumn<AsyncDocuments, string>> = [
  {
    key: 'createdOn',
    name: keyMap.sharedFieldsCreatedOn,
    render: (data: DetailsTableDataCommonType<AsyncDocuments>, value: ColumnValueType<string>): JSX.Element => {
      return <FormattedDateTime value={value} />;
    },
  },
  {
    key: 'type',
    name: keyMap.sharedFieldsType,
    render: (data: DetailsTableDataCommonType<AsyncDocuments>, value: ColumnValueType<string>) =>
      value && getValueFromEnums(value, ENUM_CONSTANTS.DOCUMENT_TYPE),
  },
  {
    key: 'subType',
    name: keyMap.sharedFieldsSubtype,
    render: (data: DetailsTableDataCommonType<AsyncDocuments>, value: ColumnValueType<string>) =>
      value && getValueFromEnums(value, ENUM_CONSTANTS.DOCUMENT_SUB_TYPE),
  },
  {
    key: 'documentNumber',
    name: keyMap.settingsDocsFormDocumentNumber,
  },
  {
    key: 'status',
    name: keyMap.commonStatus,
    render: (data: DetailsTableDataCommonType<AsyncDocuments>, value: ColumnValueType<string>) =>
      value && getTableLabel(value, ENUM_CONSTANTS.DOCUMENT_STATUS),
  },
];
